// ==============================|| OVERRIDES - AUTOMATIC ERROR ||============================== //

export default function StepperValidation(theme) {
  return {
    MuiStepLabel: {
      styleOverrides: {
        root: {
          '& *': { cursor: 'pointer !important' } // Your previous requirement
        },
        label: {
          '&.Mui-error': {
            color: theme.palette.error.main // Turns text red
          }
        },
        iconContainer: {
          '& .MuiStepIcon-root.Mui-error': {
            color: theme.palette.error.main // Turns the circle/icon red
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: theme.palette.error.main // Makes '*' red by default
        }
      }
    }
  };
}
